import { useMemo, useState } from "react";
import {
  Environment,
  SupriseAndPriceHistory,
  useSurpriseAndPriceHistory,
} from "@iliotech/watchlist-api";
import styles from "./EpsSurpriseChart.module.scss";
import { FromPeriodChooser } from "../../InstrumentOverview/components/FromPeriodChooser/FromPeriodChooser";
import { Toggle } from "@widgets/components/Toggle/Toggle";
import moment from "moment";
import { EpsSurpriseColumnChart } from "./EpsSurpriseColumnChart";
import { EpsRelativePricePerformance } from "./EpsRelativePricePerformance";
import { MarketInformationButtonModal } from "@widgets/components/MarketInformationButton/MarketInformationButtonModal";
import { EPS_SURPRISE_INFO_TEXT } from "./constants";
interface IOwnProps {
  instrumentId: string;
  watchlistId: string;
  token: string;
  environment: Environment;
  minDate: string;
}
const DEFAULT_MIN_DATE = "2020-01-01";
const DEFAULT_FROM_DATE = moment().subtract(3, "year").format("YYYY-MM-DD");
export const EpsSurpriseChart = ({
  instrumentId,
  watchlistId,
  token,
  environment,
  minDate,
}: IOwnProps) => {
  const [fromDate, setFromDate] = useState<string>(DEFAULT_FROM_DATE);
  const [selectedMode, setSelectedMode] =
    useState<"EPS surprise" | "Price Overlay">("EPS surprise");
  const { data } = useSurpriseAndPriceHistory(
    environment,
    instrumentId,
    token,
    watchlistId,
    fromDate
  );

  const surpriseAndPriceHistory = data?.priceDates || [];
  const renderInner = useMemo(() => {
    if (selectedMode === "EPS surprise") {
      return (
        <div>
          <EpsSurpriseColumnChart data={surpriseAndPriceHistory!} />
        </div>
      );
    }
    return (
      <div>
        <EpsRelativePricePerformance data={surpriseAndPriceHistory!} />
      </div>
    );
  }, [surpriseAndPriceHistory, selectedMode]);

  return (
    <div>
      <div className={styles.sectionContainer}>
        <div className={styles.row}>
          <FromPeriodChooser
            fromDate={fromDate}
            setFromDate={setFromDate}
            minDate={minDate}
          />
          <MarketInformationButtonModal
            infoText={EPS_SURPRISE_INFO_TEXT}
            title="EPS Surprise Information"
          >
            <span>More Info</span>
          </MarketInformationButtonModal>
        </div>
        <div className={styles.row}>
          <h2>EPS Surprise</h2>
          <Toggle
            position={selectedMode === "EPS surprise" ? "LEFT" : "RIGHT"}
            left={"EPS surprise"}
            right={"Price"}
            onClick={(val) => {
              setSelectedMode(
                val === "LEFT" ? "EPS surprise" : "Price Overlay"
              );
            }}
          />
        </div>
        {renderInner}
      </div>
    </div>
  );
};
